import React, { useContext } from "react";
import Styles from "./PurchaseListCard.module.scss";
import { useTranslation } from "react-i18next";
import { AuthContext } from "components/lib";
import { AccessTime, ImportContacts } from "@mui/icons-material";
import Badge, { BADGE_TYPES } from "components/global/CardBadge/CardBadge";
import { useMemo } from "react";

const PurchaseListCard = (props) => {
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const currencySymbol = authContext?.user.currencySymbol;

    const price = props?.data?.pricing;

    const courseCount = props?.data?.labCount || 0;
    const moduleCount = props?.data?.nodeCount || 0;

    function getCertDuration(data) {
        const count = data?.labsData?.
            labs?.reduce((acc, labData) => {
                const originalLab = data?.labs?.labs?.find(lab => lab.lab_id === labData.lab_id);
                const multiplier = originalLab?.is_project ? 2 : 1;
                const nodeCount = labData?.nodeCount
                return acc + (nodeCount * multiplier)
            }, 0)
        return count
    }
    const durationHours = useMemo(() => {
        if (props?.type === "cert") {
            return getCertDuration(props.data);
        }

        const multiplier = props?.data?.is_project ? 2 : 1;
        return moduleCount * multiplier;
    }, [props.type, props.data, moduleCount]);
    const displayCount = props.type === "cert" ? courseCount : moduleCount;
    const labelKey = props.type === "cert" ? "course" : "modules";

    const plan = authContext?.user?.plan;

    const isHybrid = plan === 'hybrid';
    const isScholar = plan === 'free';
    const isPurchaseMode = props?.mode === 'purchase';
    const isEnrollMode = props?.mode === 'enroll';

    const shouldShowBadge = (() => {
        if ((isScholar || isHybrid) && isPurchaseMode) return true;

        if (isEnrollMode && !isHybrid) {
            return Boolean(props?.data?.association);
        }

        return false;
    })();


    const resolveBadgeConfig = (data) => {
        if (data?.association) {
            return {
                type: BADGE_TYPES.INFO,
                label: 'Certificate Exclusive',
            };
        }

        if (data?.renew) {
            return {
                type: BADGE_TYPES.WARN,
                label: 'Pending Renewal',
            };
        }

        if (props?.type === "internship") {
            return null;
        }

        return {
            type: BADGE_TYPES.SUCCESS,
            label: 'Free Trial',
        };
    };

    const badgeConfig = resolveBadgeConfig(props?.data, props?.type);

    return (
        <div
            data-testid="PurchaseListCard-container"
            className={Styles.container}
            onClick={() => { props?.data?.association ? props?.handleAssociation?.(props?.data?.association) : props?.onCardClick?.(props?.data) }}
        >
            {/* --- BADGE --- */}
            {props?.showBadge && shouldShowBadge && badgeConfig && (
                <Badge data-testid="PurchaseListCard-badge" type={badgeConfig.type}>
                    {badgeConfig.label}
                </Badge>
            )}

            <div data-testid="PurchaseListCard-cardContent" className={Styles.cardContent}>
                {/* IMAGE */}
                <div data-testid="PurchaseListCard-imageBox" className={Styles.imageBox}>
                    <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${props?.data?.icon || props?.data?.image}`} alt="course" />
                </div>

                {/* TEXT COLUMN */}
                <div data-testid="PurchaseListCard-mainText" className={Styles.mainText}>
                    <h3 className={Styles.title}>
                        {props?.data?.name || props?.data?.title}
                    </h3>

                    {(props.data.description || props.data.descr) && (
                        <p className={Styles.description}>
                            {props?.data?.description || props?.data?.descr}
                        </p>
                    )}

                    {/* INFO ROW */}
                    <div data-testid="PurchaseListCard-infoRow" className={Styles.infoRow}>
                        {(props?.type !== "internship") && <div data-testid="PurchaseListCard-infoItem" className={Styles.infoItem}>
                            <ImportContacts fontSize="small" sx={{ color: '#1450a0' }} />
                            {displayCount} {t(`PurchaseCards.PurchaseListCards.PurchaseListCard.${labelKey}`)}
                        </div>}

                        {(props?.type !== "internship") && <div data-testid="PurchaseListCard-infoItem1" className={Styles.infoItem}>
                            <AccessTime fontSize="small" sx={{ color: '#1450a0' }} />
                            {durationHours} {t('PurchaseCards.PurchaseListCards.PurchaseListCard.hours')}
                        </div>}

                        <span className={Styles.access}>
                            {t('PurchaseCards.PurchaseListCards.PurchaseListCard.access', { months: price?.interval })}
                        </span>
                    </div>
                </div>

                {/* ---------------- PRICE BLOCK ---------------- */}
                {(isPurchaseMode) && (
                    <div data-testid="PurchaseListCard-priceBlock" className={Styles.priceBlock}>

                        <div data-testid="PurchaseListCard-index" key={`${price?.id}`} className={Styles.priceCol}>
                            {/* MAIN PRICE */}
                            <div data-testid="PurchaseListCard-mainPrice" className={Styles.mainPrice}>
                                {currencySymbol}{price?.price}
                            </div>

                            {/* STRIKE PRICE */}
                            {price?.actual_price && (
                                <div data-testid="PurchaseListCard-strikePrice" className={Styles.strikePrice}>
                                    <span style={{
                                        textDecoration: "line-through",
                                        color: "gray",
                                        fontSize: "14px"
                                    }}>
                                        {currencySymbol}{price?.actual_price}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PurchaseListCard;